'use strict';

angular.module('webAgro1App').filter('sum', function() {
  return function(items, field) {
    if (!items || !field) {
      return;
    }

    return items.reduce(function(result, item) {
      var value = +_.get(item, field) || 0;
      return result + value;
    }, 0);
  };
});
